import React, { useState } from 'react';
import { handleDownload } from '../Conversion/Base64';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RandomContent from '../Components/RandomContent'; 

const Base64ToImage = () => {
  const [base64, setBase64] = useState('');
  const [imageSrc, setImageSrc] = useState('');

  const handleConvert = () => {
    if (base64.trim() === '') {
      toast.error('Please enter a valid Base64 string');
      return;
    }

    try {
      const isValidBase64 = base64.startsWith('data:image/') && base64.includes(';base64,');
      if (!isValidBase64) {
        toast.error('Invalid Base64 image string');
        return;
      }
      setImageSrc(base64);
      toast.success('Image converted successfully');
    } catch (error) {
      toast.error('Error converting Base64 to image');
    }
  };

  const handleDownloadWrapper = () => handleDownload(imageSrc, toast);

  return (
    <>
      <Header />
        <RandomContent />

      <div className="blog-area pb-20" >
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-12 col-md-12">
              <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                <div className="details">
                  <h4><a href="#">Convert Base64 to Image</a></h4>
                  <p>
                    Transform Base64 code into images effortlessly with Data Beautifier's Free Base64 to Image Conversion Online Tool.
                    Our Best Base64 to Image Conversion Online Tool ensures accurate and quick results, making it ideal for developers and designers.
                    The Simple Base64 to Image Converter Tool is user-friendly, requiring no technical expertise—just paste your Base64 code and get the image instantly.
                    With the Easy Base64 to Image Converter Tool, you can handle conversions with ease, saving time and effort.
                    Accessible anytime and completely free, Data Beautifier is your go-to platform for seamless Base64 to image conversion. Try it today!
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center" style={{ marginTop: '30px', gap: '20px' }}>

            {/* Base64 Input */}
            <div className="full-col col-lg-5 col-md-5">
              <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                <textarea
                  value={base64}
                  onChange={(e) => setBase64(e.target.value)}
                  rows={18}
                  placeholder="Enter Base64 string here"
                  style={{
                    width: '100%',
                    padding: '15px',
                    borderRadius: '10px',
                    border: '1px solid #ccc',
                    fontFamily: 'monospace',
                    fontSize: '14px',
                    resize: 'vertical',
                  }}
                />
              </div>
            </div>

            {/* Convert Button */}
            <div
              className="w3-col m2"
              style={{
                flex: 2,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <button
                className="default-btn icon four"
                onClick={handleConvert}
                disabled={!base64.trim()}
                style={{ minWidth: '120px' }}
              >
                <i className="ri-exchange-line"></i>
                Convert
              </button>
            </div>

            {/* Image Preview */}
            <div className="full-col col-lg-5 col-md-5">
              <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="1200" style={{ textAlign: 'center' }}>
                {imageSrc ? (
                  <>
                    <img
                      src={imageSrc}
                      alt="Converted Preview"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '300px',
                        borderRadius: '8px',
                        marginBottom: '20px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      }}
                    />
                    <button
                      onClick={handleDownloadWrapper}
                      className="default-btn icon four"
                      style={{ backgroundColor: '#E64D25', borderColor: '#E64D25' }}
                    >
                      <i className="ri-download-line"></i> Download
                    </button>
                  </>
                ) : (
                  <p style={{ color: '#999', fontStyle: 'italic' }}>Image preview will appear here after conversion.</p>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Base64ToImage;
